/**
 * ObjectAbout — what an object is, as its module declares it, in a quiet
 * muted paragraph under a page heading. Text that runs past about two lines
 * shows its first sentence with a "More about {plural}" disclosure. Draws
 * nothing where the object declares no `about`. The words are the backend's;
 * nothing here rewrites them.
 */
import { useId, useState } from "react";
import { aboutTextOf } from "@shared-core/domain/object-ui/about";

export function ObjectAbout({
  about,
  plural,
}: {
  about: string | undefined | null;
  /** The object's plural, for the disclosure's label. */
  plural: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const textId = useId();
  const text = aboutTextOf(about);
  if (!text) return null;
  return (
    <div className="max-w-[70ch] text-sm text-muted-foreground">
      <p id={textId}>{isOpen ? about!.trim() : text.lead}</p>
      {text.isTruncated && (
        <button
          type="button"
          aria-expanded={isOpen}
          aria-controls={textId}
          onClick={() => setIsOpen((open) => !open)}
          className="mt-1 text-primary hover:underline max-sm:py-2"
        >
          {isOpen ? "Less" : `More about ${plural.toLowerCase()}`}
        </button>
      )}
    </div>
  );
}
